export const getBlockPowerAndEnergyKey = (isDcCoupled) =>
  isDcCoupled ? 'acPvBlockPowerAndEnergy' : 'blockPowerAndEnergy'
